import React from 'react';
import { Icon } from 'components/common';
import { colours } from 'utils/theme';

/**
 * ActivityIcon component renders an Icon with a given icon name.
 * The icon name is passed as a prop. All other props are optional.
 * This ensures that the icon looks consistent across different activities.
 */
const ActivityIcon = ({
  icon,
  size = 'sm',
  color = colours.teal,
  fixedWidth = true,
  ...rest
}) => (
  <Icon
    icon={icon}
    size={size}
    color={color}
    fixedWidth={fixedWidth}
    {...rest}
  />
);

export default ActivityIcon;
